export enum EGeoLocationErrors {
    PERMISSION_DENIED = 'geo_permission_denied',
    POSITION_UNAVAILABLE = 'geo_position_unavailable',
    TIMEOUT = 'geo_timeout',
}